export const DOC_API_CONTROLLER_END_POINTS = {
  CONTROLLER_PATH: "",
  LIST_PATH: "list",
  ORDER_LIST_PATH: "list/order",
  UPLOAD_ORDER_PATH: "upload/order",
  COMPANY_LIST_PATH: "list/company",
  UPLOAD_CLIENT_PATH: "upload/client",
};
